import { render, staticRenderFns } from "./AddOrderMovementsToLocation.vue?vue&type=template&id=c9064b76&scoped=true"
import script from "./AddOrderMovementsToLocation.vue?vue&type=script&lang=js"
export * from "./AddOrderMovementsToLocation.vue?vue&type=script&lang=js"
import style0 from "./AddOrderMovementsToLocation.vue?vue&type=style&index=0&id=c9064b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9064b76",
  null
  
)

export default component.exports